;(function ( $ ) {

    /**
     *  openOverlay
     *  triggers event to open overlay
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'inlineOverlay';
    var defaults = {
        selector: 'main'
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.tagName = $(this.element).get(0).tagName.toLowerCase();
            if (!$(this.element).find('#inline-overlay').length) {
                this.renderOverlay();
            }
            this.registerEvents();
        },
        show: function (params) {
            var _this = this;
            console.log(params);
            $('#inline-overlay').find('.form-step-progress').remove();
            if (params && params.bg && params.bg === 'gray') {
                $('#inline-overlay').addClass('overlay-gray');
            } else {
                $('#inline-overlay').removeClass('overlay-gray');
            }
            
            if (params && params.bg && params.bg === 'event') {
                $('#inline-overlay').addClass('bg-color-event');
            } else {
                $('#inline-overlay').removeClass('bg-color-event');
            }                
            if (params && params.size && params.size === 'small') {
                $('#inline-overlay').addClass('small');
                $('#inline-overlay .overlay-content').addClass('bg-color-event');
            } else {
                $('#inline-overlay').removeClass('small');
                $('#inline-overlay .overlay-content').removeClass('bg-color-event');
            }
            if ($('#inline-overlay').hasClass('is-hidden')) {
                _this.showOverlay(params.clientX, params.clientY);
            } else {
                $('#inline-overlay').find('.overlay-content').addClass('fadeOut animated fast');
            }
            if (params.href) {
                _this.setOverlayContent(params.href, params.index, params.formData);
            }
            if (params.action) {
                _this.setFormOverlayContent(params);
            }
            // if($('html').hasClass('touch')){
                
            //     $('#inline-overlay').css({position: 'absolute'});
            //     $('body, html').css({'overflow': 'hidden'});

            //     $('#inline-overlay').show();
            //     setTimeout(function (){
            //         window.scrollTo(0, 0);
            //         $('body, html').css({'max-height': '500px'});
            //     },0);
            // }
        },
        showOverlay: function(clientX, clientY) {
            if (!clientX) {
                clientX = $(window).width() / 2;
            }
            if (!clientY) {
                clientY = $(window).height() / 2;
            }
            console.log('top',$(window).scrollTop());
            var top = clientY - 10 ;//+ $(window).scrollTop();
            var bottom = clientY + 10;
            var left = clientX - 10;
            var right = clientX + 10;
            var width = 20;
            var height = 20;

            $('#inline-overlay').find('.overlay-content').hide();
            // $('#inline-overlay').find('.inline-overlay-close').hide();
            $('#inline-overlay').css({
                'width': width,
                'height': height,
                'top': top,
                'left': left,
                'bottom': bottom,
                'right': right
            }).animate({
                'width': '100%',
                'height': '100%',
                'top': '36px',
                'left': 0,
                'bottom': 0,
                'right': 0
            }, 200, 'easeInOutQuad', function() {
                // animation complete
               $('#inline-overlay').find('.overlay-content').show().addClass('animated fadeIn fast');
               if (!$('#inline-overlay').find('.inline-overlay-close').length) {
                    $('#inline-overlay').find('.overlay-content')
                        .append('<a class="inline-overlay-close color-light color-event-hover" href="#"><span class="icon icon-close"></span></a>');
               }
               // $('#inline-overlay').find('.inline-overlay-close').show();
            });
            $('#inline-overlay').removeClass('fadeOut').removeClass('is-hidden').addClass('animated fadeIn fast');
            // $(this.element).addClass('noscroll');
        },
        hideOverlay: function() {
            $(this.element).removeClass('noscroll');
            // $('#inline-overlay').find('.inline-overlay-close').hide();
            $('#inline-overlay').removeClass('fadeIn').addClass('fadeOut');
            window.setTimeout(function() {
                $('#inline-overlay').addClass('is-hidden');
                $('#inline-overlay').removeClass('fadeOut').removeClass('animated').removeClass('fast');
                // if($('html').hasClass('touch')){
                //     $('body, html').css({'overflow': 'auto'});
                //     $('body, html').css({'max-height': 'initial'});
                //     $('footer').css({'position': 'relative'});
                // }
            }, 200);
            
            $(document).off('touchmove');
        },

        showLoadingScreen: function() {
            $('#inline-overlay')
                .find('.overlay-content')
                .empty()
                .removeClass('fadeIn').removeClass('fadeOut').removeClass('animated').removeClass('fast')
                .append('<div class="overlay-loading"><div class="loading-indicator"><span></span></div></div>');
        },
        setOverlayContent: function(url, index, formData) {
            var _this = this;
            this.showLoadingScreen();
            $.ajax({
                type : 'get',
                url : url,
                cache : false,
                async : false,
                dataType : 'html',
                error : function() {
                    // no notification at the moment
                    $('#inline-overlay').find('.overlay-content').empty().removeClass('fadeOut').html('<h1>ERROR!</h1>').addClass('fadeIn animated fast');
                },
                success : function(data) {
                    $('#inline-overlay').find('.overlay-content').empty();
                    $('#inline-overlay').find('.overlay-content')
                        .append('<a class="inline-overlay-close color-light color-event-hover" href="#"><span class="icon icon-close"></span></a>');
                    
                    var html = jQuery.parseHTML(data, document, true);
                    console.log('loaded', html);
                    $.each(html, function(index, elem) {
                        // if the element's id matches the outer if, append the childs only
                        if (elem.tagName && (elem.tagName.toLowerCase() == _this.settings.selector)) {
                            $('#inline-overlay').find('.overlay-content').append($(elem));
                        }
                    });
                    $('#inline-overlay').find('.overlay-content').removeClass('fadeOut').addClass('fadeIn animated fast');
                    if (index !== undefined) {
                        $('#inline-overlay').find('form').append('<input type="hidden" name="index" value="' + index + '" />');
                        if (formData) {
                            $('#inline-overlay').find('form').find('select[name="salutation"]').find('option[value="' + formData.salutation + '"]').attr('selected', 'selected');
                            $('#inline-overlay').find('form').find('select[name="title"]').find('option[value="' + formData.title + '"]').attr('selected', 'selected');
                            $('#inline-overlay').find('form').find('select[name="country"]').find('option[value="' + formData.country + '"]').attr('selected', 'selected');
                            $('#inline-overlay').find('form').find('input[name="givenname"]').val(formData.givenname);
                            $('#inline-overlay').find('form').find('input[name="surname"]').val(formData.surname);
                            $('#inline-overlay').find('form').find('input[name="company"]').val(formData.company);
                            $('#inline-overlay').find('form').find('input[name="email"]').val(formData.email);
                        }
                    }
                    initPlugins($('#inline-overlay'));
                }
            });
        },
        registerEvents: function() {
            var _this = this;
            $(document).on('click', '.inline-overlay-close, .inline-close-overlay', function(e) {
                e.preventDefault();
                _this.hideOverlay();
            });

            if (this.tagName == 'form') {
                $(this.element).on('click', 'button', function() {
                    $(this).addClass('is-active');
                });
                $(this.element).on('submit', function(e) {
                    var extraParams = {};
                    extraParams.method = $(this).attr('method').toLowerCase();
                    extraParams.action = $(this).attr('action');
                    if ($(this).hasClass('overlay-gray')) {
                        extraParams.bg = 'gray';
                    }
                    if ($(this).hasClass('overlay-event')) {
                        extraParams.bg = 'event';
                    }
                    if ($(this).hasClass('small')) {
                        extraParams.size = 'small';
                    }
                    extraParams.formData = $(this).serializeArray();
                    extraParams.formData.push( { 'name': 'action', 'value': $(this).find('button.is-active').attr('name') } );
                    e.preventDefault();
                    _this.show(extraParams);
                });
            } else {
                $(this.element).on('click', function(e) {
                    // if($(this.element).hasClass('.inline-overlay')){
                        e.preventDefault();
                    // }
                    var extraParams = {};
                    extraParams.clientX =  e.clientX;
                    extraParams.clientY = e.clientY;
                    extraParams.href = $(this).attr('href');
                    if ($(this).data('index') !== undefined) {
                        extraParams.index = $(this).data('index');
                        if ($(this).parents('.li-ticket').length) {

                            extraParams.formData = {
                                salutation: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-salutation').val(),
                                title: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-title').val(),
                                givenname: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-givenname').val(),
                                surname: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-surname').val(),
                                company: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-company').val(),
                                country: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-country').val(),
                                email: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-email').val()
                            };
                        }
                    }
                    if ($(this).hasClass('overlay-gray')) {
                        extraParams.bg = 'gray';
                    }
                    
                    if ($(this).hasClass('overlay-event')) {
                        extraParams.bg = 'event';
                    }
                    if ($(this).hasClass('small')) {
                        extraParams.size = 'small';
                    }
                    if (extraParams.href) {
                        _this.show(extraParams);
                    }
                    if ($(this).attr('data-target') !== '' && $(this).attr('data-validate') !== '') {
                        extraParams.target = $(this).attr('data-target');
                        extraParams.validate = $(this).attr('data-validate');
                        extraParams.text = '';
                        if($(this).attr('data-text-id') !== ''){
                            var textID = $(this).attr('data-text-id');
                            extraParams.text = $('#'+textID).text();
                        }
                        console.log('data-found');
                        $(document).on('click', '.inline-close-overlay.validate', function(e) {
                            console.log('validate');
                            e.preventDefault();
                            $.ajax({
                                type : 'get',
                                url : extraParams.target+'?validate='+extraParams.validate+'&text='+extraParams.text,
                                cache : false,
                                async : false,
                                dataType : 'html',
                            });
                        });
                    }
                });
            }
        },
        renderOverlay: function() {
            var html = '<div class="overlay is-hidden" id="inline-overlay" style="z-index: 9999;">' +
                '<div class="overlay-content"></div></div>';
            $('body').append(html);
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
